import React, { useContext, useCallback, useState } from 'react';
import { Chevron } from '@jutro/components';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesComponent from '../../CoveragesComponent/CoveragesComponent';

import metadata from './PolicyCoverageComponent.metadata.json5';
import messages from './PolicyCoverageComponent.messages';
import styles from '../PolicyFarmInformationComponent/PolicyFarmInformationComponent.module.scss';
// import styles from './PolicyCoverageComponent.module.scss';

function PolicyCoverageComponent(props) {

    const translator = useContext(TranslatorContext);
    const [foCoverageOpenItems, SetFoCoverageOpenItems] = useState([]);
    const [farmCoverageOpenItems, SetFarmCoverageOpenItems] = useState([]);

    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(foCoverageOpenItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                SetFoCoverageOpenItems(openedItem);
            } else {
                SetFoCoverageOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [foCoverageOpenItems]
    );

    const getFarmLOBData = () => {
        const farmLOBData = _.cloneDeep(props.value);
        return farmLOBData;
    };

    const farmLOBData = getFarmLOBData();

    const getHeaderSection = (title, title1) => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
                <h2 className={`${styles.customAccordion_cardTitle} `}>{title}</h2>
                <h3 className={`${styles.customAccordion_cardTitle2} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
            </React.Fragment>
        );
    };

    const generateAccordionHeaderOverrides = useCallback(() => {
        const overrides = farmLOBData.farmerInsured.map((farmerInsured, index) => {
            const count = index + 1;
            return {
                /*[`farmPolicyCoverageComponentCard`]: {
                    header: getHeaderSection(translator(messages.farmersAccidentSection), " ")
                },*/
                [`foShowContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`foContentDetailToggle${index}`]: {
                    icon: _.includes(foCoverageOpenItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(foCoverageOpenItems, index)
                        ? translator(messages.hideInsuredsCoverages)
                        : translator(messages.showInsuredsCoverages)
                },
                [`foCoverageContainer${index}`]: {
                    visible: _.includes(foCoverageOpenItems, index),
                    show: foCoverageOpenItems
                },
                [`fobPackageDetailsContainer${index}`]: {
                    header: getHeaderSection(farmerInsured.farmerInsured, farmerInsured.beneficiary)
                },

            }
        });
        return Object.assign({}, ...overrides);
    }, [farmLOBData, farmCoverageOpenItems]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'locations') {
                return farmLOBData.locations;
            }
            return _.get(farmLOBData, path);
        },
        [farmLOBData]
    );
    function getCell(items, index, property) {
        return items[property.id];
    };


    const overrides = {
        farmersAccidentTableGrid: {
            data: farmLOBData.farmerInsured,
            visible: farmLOBData.farmerInsured.length > 0
        },
        brokerEndorsementsEmptyMsg: {
            visible: farmLOBData.brokerEndorsements && farmLOBData.brokerEndorsements.length === 0
        },
        noFarmersAccidentEmptyMsg: {
            visible: farmLOBData.farmerInsured.length === 0
        },
        farmPolicyCoverageComponentCard: {
            header: getHeaderSection('Farmers Accident', "")
        },
        farmBrokerEndorsementsComponentCard: {
            header: getHeaderSection(translator(messages.brokerEndorsements), " "),
            visible: farmLOBData.brokerEndorsements && farmLOBData.brokerEndorsements.length > 0
        },
        ...generateAccordionHeaderOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            getCell: getCell,
        },
        resolveComponentMap: {
            coveragesComponent: CoveragesComponent,
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={farmLOBData}
            overrideProps={farmLOBData.locations ? overrides : {}}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

PolicyCoverageComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};
export default PolicyCoverageComponent;
